<template>
  <Popover :header="help.header" :title="help.title" :message="help.message" :helpLink="help.link">
    <Icon
      :alt="help.header"
      class="help-icon ml-1"
      :icon="help.icon || 'help'"
      :color="help.color || 'epsilon'"
    />
  </Popover>
</template>

<script>
import Icon from "@/components/display/icon/Icon";
import Popover from "@/components/display/Popover";

export default {
  name: "LearnMore",
  components: { Icon, Popover },
  props: {
    help: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.help-icon {
  display: inline-flex;
  vertical-align: bottom;
}
</style>
